import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ServiceDeskContextData } from '@atlassian/jira-navigation-types/src/types.tsx';
// eslint-disable-next-line jira/import-whitelist
import { prefetchApiReadyMark } from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import { getProjectKeyOrIdFromMatchAndQuery } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-or-id/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	{ match, query }: RouterDataContext,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	{ tenantContext: { baseUrl } }: ResourceStoreContext,
): Promise<ServiceDeskContextData> => {
	const projectKey = getProjectKeyOrIdFromMatchAndQuery({ match, query });
	try {
		const data = await fetchJson(
			`/rest/servicedesk/1/pages/agent/servicedesk/${projectKey}?operation=getProjectKeyOrIdFromMatchAndQuery`,
		);

		setMark(prefetchApiReadyMark);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'jiraServicedeskContextResource',
				packageName: 'jiraRouterResourcesServiceDeskContext',
			},
			error,
		});
		log.safeErrorWithoutCustomerData(
			'spa.router.resource.sd.servicedesk.context',
			'fetchData',
			error,
		);
		throw error;
	}
};
